var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"indicador-selecao",class:{'indicador-selecao-selecionado': _vm.selecionado},style:(_vm.dimensoes),attrs:{"aria-hidden":"true"}})
}
var staticRenderFns = []

export { render, staticRenderFns }